<template>
    <div>
        <template v-if="topupPayments !== null && topupPayments!== false">
            <virtualAccountComponent v-if="$global.user_vr_corp == 'YES'" :paymentType="'topup_payment'" :topup_id="payroll_id" :payrollTotalAmount="payrollTotalAmount"></virtualAccountComponent>
            <fincaComponent v-else-if="paymentEngine == 'FINCA'" :paymentType="'topup_payment'" :topup_id="payroll_id"></fincaComponent>
            <!--Sent to Checker Modal -->
            <div class="modal fade" id="sendToChecker" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct? </h2>
                            <button type="button" class="btn btn-primary submit_form sendtochecker" @click="sendForChecker()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" > No</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Sent to Approver Modal -->
            <div class="modal fade" id="sendToApprover" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Wait! Are you sure everything is correct?  </h2>
                            <button type="button" class="btn btn-primary sendtoapprover" @click = "sendForApprover()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>
            <!--Delete Modal -->
            <div class="modal fade" id="deletePop" tabindex="-1" role="dialog" aria-labelledby="sendToCheckerLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body send-to-checker-popup text-center p-4">
                            <span class="exclamation-outer">
                                <i class="fas fa-exclamation"></i>
                            </span>
                            <h2 class="mt-4 mb-3"> Do you really want to delete?  </h2>
                            <button type="button" class="btn btn-primary delete" @click="deleteBatch()">Yes</button>
                            <button type="button" class="btn btn-primary" data-dismiss="modal" aria-label="Close" >No</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="msg == null">
                <div class="page-top dropdown mb-1 mb-3 clearfix">
                <h1 class="float-left">  {{ payrollName }} <span class="highlight-color">({{ payrollTotalAmount }} PKR)  </span> </h1>
                    <button class="btn btn-primary float-right mr-1" v-if="( payrollList != null &&  payrollList.status == 1 && process_topup_payment  == true && this.$global.user_vr_balance > payrollTotalAmount)|(payrollList != null &&  payrollList.status == 2 && process_topup_payment  == true  && this.$global.user_vr_balance > payrollTotalAmount)|(payrollList != null &&  payrollList.status == 3 && process_topup_payment  == true&& this.$global.user_vr_balance > payrollTotalAmount)" data-toggle="modal" data-target="#loginMoblizer"> Process </button>
                    <button class="btn btn-primary float-right mr-1" @click = "sendToCheckerPopup()" v-if="payrollList != null && payrollList.status == 1 && sendForCheckerButton == true" data-toggle="modal" data-target="#sendToChecker"> Send To Checker </button>
                    <button class="btn btn-primary float-right mr-1"  @click = "sendToApproverPopup()" v-if="payrollList != null && payrollList.status == 2 && sendForApproverButton == true " data-toggle="modal" data-target="#sendToApprover"> Send To Approver </button>
                    <button class="btn btn-primary float-right mr-1 archived" v-if="payrollList != null && payrollList.status == 11 && archive_topup_payment == true" @click="archiveBatch()" data-toggle="modal"> Archive Batch </button>
                    <button class="btn btn-primary float-right mr-1 " @click="deletePopup()" v-if="(delete_topup_payment == true && payrollList != null && (payrollList.status == 1 || payrollList.status == 7)) "  data-toggle="modal" data-target="#deletePop"> Delete Batch </button>
                    <button class="btn btn-primary float-right mr-1 " v-if="(payrollList != null && payrollList.status == 2 && reject_topup_payment == true && process_topup_payment  == true ) | (payrollList != null && payrollList.status == 3 && reject_topup_payment == true && process_topup_payment  == true )"  data-toggle="tooltip" data-placement="bottom" title="The batch will be sent back to checker for correction" @click = "rejectApproverPopup()"> Reject Batch </button>
                    <button class="btn btn-primary float-right mr-1 " @click="rejectCheckerPopup()"  v-else-if="(payrollList != null && payrollList.status == 2 && reject_topup_payment == true && payrollList.status !=7)  | (payrollList != null && payrollList.status == 3 && reject_topup_payment == true && payrollList.status !=7 )"  data-toggle="dropdown"> Reject Batch </button>
                 <div class="dropdown-menu reupload-dropdown dropdown-menu-right">
                    <div class="dropdown-content">
                        <div class="user-section mb-3">
                            <span  v-if="currentUserImage != null" class="user-image">
                               <img v-bind:src="'/avatar/'+currentUserImage" alt="" class="user-image"/>
                            </span>
                            <span v-else class="user-image">{{firstLetter}}</span>
                            <p class="">
                                <span class="user-status user-name">{{currentUserName}}</span>
                                <span class="user-status user-designation">{{currentUserRole  }}</span>
                            </p>
                        </div>
                        <form @submit.prevent="disapproveBatch" v-if="action == 'disapprove'">
                            <div class="form-group mb-3">
                                <textarea placeholder="Why are you disapproving this batch?" class="form-control"  v-model="formDisapprove.comment"  name="comment" id="comment" :class="{ 'is-invalid': formDisapprove.errors.has('comment')}" ></textarea>
                                <has-error :form="formDisapprove" field="comment"></has-error>
                            </div>
                            <div class="btn-holder text-right">
                                <button type="" class="btn btn-primary btn-block disapprove" value="Submit"> Disapprove</button>
                            </div>
                        </form>
                        <form @submit.prevent="rejectApproverBatch" v-if="action == 'rejectApprover'">
                            <div class="form-group mb-3">
                                <textarea placeholder="Why are you revising this batch?" class="form-control"  v-model="formRejectApprover.comment"  name="comment" id="comment" :class="{ 'is-invalid': formRejectApprover.errors.has('comment')}" ></textarea>
                                <has-error :form="formRejectApprover" field="comment"></has-error>
                            </div>
                            <div class="btn-holder text-right">
                                <button type="" class="btn btn-primary btn-block rejectApprover" value="Submit"> Revise</button>
                            </div>
                        </form>
                        <form @submit.prevent="rejectCheckerBatch" v-if="action == 'rejectChecker'">
                            <div class="form-group mb-3">
                                <textarea placeholder="Why are you revising this batch?" class="form-control"  v-model="formRejectChecker.comment"  name="comment" id="comment" :class="{ 'is-invalid': formRejectChecker.errors.has('comment')}" ></textarea>
                                <has-error :form="formRejectChecker" field="comment"></has-error>
                            </div>
                            <div class="btn-holder text-right">
                                <button type="" class="btn btn-primary btn-block rejectChecker" value="Submit"> Revise</button>
                            </div>
                        </form>
                        <form @submit.prevent="reUploadBatch" v-if="action == 'reUpload'">
                            <div class="form-group mb-3">
                                <textarea placeholder="Why are you re-uploading this batch?" class="form-control"  v-model="formReUpload.comment"  name="comment" id="comment" :class="{ 'is-invalid': formReUpload.errors.has('comment')}" ></textarea>
                                <has-error :form="formReUpload" field="comment"></has-error>
                            </div>
                            <div class="btn-holder text-right">
                                <button type="" class="btn btn-primary btn-block reUpload" value="Submit"> Re-Upload</button>
                            </div>
                        </form>
                    </div>
                </div>
                <button class="btn btn-primary float-right mr-1 " @click = "disapprovePopup()" v-if="(payrollList != null && payrollList.status == 1 && disapprove_topup_payment == true ) | (payrollList != null && payrollList.status == 2 && disapprove_topup_payment == true ) |(payrollList != null && payrollList.status == 3 &&  disapprove_topup_payment == true )"  data-toggle="dropdown" data-placement="bottom" title="The batch will be cancelled completely" data-target="#daa" aria-haspopup="true" aria-expanded="false" data-offset="0,10"> Disapprove </button>
                <!-- BELOW COMMENTED LINE TO BE USED IN FUTURE -->
                 <!-- <button class="btn btn-primary float-right mr-1 " @click = "reUploadPopup()" v-if="reUploadButton == true"  data-toggle="dropdown" data-target="#daa" aria-haspopup="true" aria-expanded="false" data-offset="0,10"> Re-Upload </button> -->
                 <div class="head-date float-right mr-2">{{payrollDate}} <i class="fas fa-calendar-alt"></i> </div>
                <!-- request data -->
                <div style="display:none">{{payroll_id}}</div>
                </div>
                <div class="batch-history mb-3 clearfix" v-if="batchHistory != null">
                    <h2> <span class="text"> Batch History </span> </h2>
                    <ul class="batch-status-list" >
                     <li class="status-list-item dropdown" v-for="bh in batchHistory" :key="bh.id" v-show="bh.action == 'UPLOAD' | bh.action == 'REUPLOADED'| bh.action == 'FLAGGED'| bh.action == 'CHECKED'| bh.action == 'APPROVED' |bh.action == 'DISAPPROVED' |bh.action == 'DELETED' | bh.action == 'ARCHIVED' | bh.action == 'PAID'">
					       <span class="status uploaded" v-show="bh.action == 'UPLOAD'"> Uploaded</span>
                           <span class="status checked" v-if="bh.action == 'CHECKED'"> Checked </span>
                           <span class="status completed" v-if="bh.action == 'APPROVED'"> Approved </span>
                           <span class="status rejected" v-if="bh.action == 'DELETED'"> Deleted </span>
                           <span class="status proccessed" v-if="bh.action == 'PAID'"> PAID </span>
                           <span class="status archived" v-if="bh.action == 'ARCHIVED'"> Archived </span>
                           <span class="status uploaded" v-if="bh.action == 'REUPLOADED'"> Re-uploaded
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img src="/images/flag.png" alt="" />  0 </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image"><img v-bind:src="'/avatar/'+bh.image" alt=""   class="user-image"/> </span>
						    		  <p class="">
						    			<span class="user-status user-name">{{bh.username}}</span>
						    			<span class="user-status date">{{bh.updated_at}}</span>
						    		  </p>
						    	   </div>
						    	   <div class="text">
						    		 <p> {{bh.comment}} </p>
						    	   </div>
						      </div>
						     </div>
					       </span>
                           <span class="status flagged" v-if="bh.action == 'FLAGGED'"> Flagged
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img src="/images/flag.png" alt="" />    </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image"><img v-bind:src="'/avatar/'+bh.image" alt=""  class="user-image" /> </span>
						    		  <p class="">
						    			<span class="user-status user-name">{{bh.username}}</span>
						    			<span class="user-status date">{{bh.updated_at}}</span>
						    		  </p>
						    	    </div>
						    	    <div class="text">
						    		 <p> {{bh.comment}} </p>
						    	    </div>
						       </div>
						     </div>
					       </span>
                           <span class="status rejected" v-if="bh.action == 'DISAPPROVED'"> Disapproved
						      <div class="dropdown-menu reupload-dropdown flagged-message dropdown-menu-right">
						       <div class="dropdown-content">
						         	<div class="flag"> <img src="/images/flag.png" alt="" />  </div>
						      	    <div class="user-section mb-3">
						    		 <span class="user-image"><img v-bind:src="'/avatar/'+bh.image" alt=""  class="user-image"/> </span>
						    		  <p class="">
						    			<span class="user-status user-name">{{bh.username}}</span>
						    			<span class="user-status date">{{bh.updated_at}}</span>
						    		  </p>
						    	   </div>
						    	   <div class="text">
						    		 <p> {{bh.comment}} </p>
						    	   </div>
						       </div>
						      </div>
					       </span>
				     </li>
                    </ul>
                </div>
            <div class="batch-history mb-3 clearfix" v-else>
              <h2> <span class="text"> Batch History </span> </h2>
              <ul class="batch-status-list">
                <li class="status-list-item" ></li>
              </ul>
            </div>
            <div class="batch-process-history mb-1">
                    <div class="batch-process-outer mb-2" v-for="bh in batchHistory" :key="bh.id" v-show="bh.action == 'UPLOAD' | bh.action == 'REUPLOADED'| bh.action == 'FLAGGED'| bh.action == 'CHECKED'| bh.action == 'APPROVED' |bh.action == 'DISAPPROVED' |bh.action == 'DELETED' | bh.action == 'ARCHIVED' | bh.action == 'PAID'">
                        <div class="batch-process-inner created-by"  v-if="bh.action == 'UPLOAD'">
                            <span class="action-by"> Created By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner reuploaded-by"  v-if="bh.action == 'REUPLOADED'">
                           <span class="action-by"> Reuploaded By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner flagged-by"  v-if="bh.action == 'FLAGGED'">
                            <span class="action-by"> Rejected By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner checked-by" v-if="bh.action == 'CHECKED'">
                            <span class="action-by"> Checked By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                        {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner approved-by" v-if="bh.action == 'APPROVED'">
                            <span class="action-by"> Approved By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner disapprove-by" v-if="bh.action == 'DISAPPROVED'">
                            <span class="action-by"> Disapproved By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>

                            </div>
                            <div class="created-date text-right">  {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner deleted-by" v-if="bh.action == 'DELETED'">
                            <span class="action-by"> Deleted By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner archived-by" v-if="bh.action == 'ARCHIVED'">
                            <span class="action-by"> Archived By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                        <div class="batch-process-inner paid-by" v-if="bh.action == 'PAID'">
                            <span class="action-by"> PAID By </span>
                            <div class="process-content">
                                <div class="user" v-if="bh.image != ''">
                                    <img v-bind:src="'/avatar/'+bh.image" alt="" />
                                </div>
                                <div class="user" v-else>
                                    <img src="/images/table-dummy-image.jpg" alt="" />
                                </div>
                                <p class="batch-process-text">
                                    <strong class="title" :title="bh.username"> {{ bh.username }} </strong>
                                    {{bh.designation}}
                                </p>
                            </div>
                            <div class="created-date text-right"> {{ bh.created_at | date_format }} </div>
                        </div>
                    </div>
            </div>
             <div v-if="this.$global.user_vr_corp == 'YES' && this.payrollStatus < 4 & this.payrollTotalAmount > this.$global.user_vr_balance" class="alert alert-danger" role="alert">
                    <p><b> Warning! </b> Your account has insufficient balance for this batch to process. Current Balance : {{this.$global.user_vr_balance}}</p>
            </div>
            <div class="alert alert-warning" role="alert" v-if="unRegisterNumberExport > 0">
                <p><b> Warning! </b> Un-registered record(s) found in the batch.</p>
            </div>
            <div class="btns-holder mb-3 clearfix">
                <div class="field-box float-left"  v-if="exportBatch === true">
                    <button class="btn btn-primary export" @click="batchExport">Export Batch</button>
                </div>
               <a class="btn btn-primary float-left ml-1" v-if="unRegisterNumberExport > 0" @click="unRegisterNumberExportFn" href="javascript:void(0)"> Un-registered Record[s] </a>
                <a class="btn btn-primary float-left ml-1" v-if="failedCount > 0" @click="failedTransactionsExport" href="javascript:void(0)"> Failed Transactions </a>
            </div>
            <div class="table">
                <table id="viewTopupPaymentTable" class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Mobile Number</th>
                            <th>Network</th>
                            <th>Type</th>
                            <th>Amount</th>
                            <th v-if="statusTD == true">Status</th>
                        </tr>
                    </thead>
                </table>
                </div>
            </div>
            <div v-else> <h1> {{msg}}</h1></div>
        </template>
        <template v-else-if="topupPayments == null ">
           <preLoader></preLoader>
        </template>
        <template v-else-if="topupPayments == false">
          <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
import fincaComponent from '../modals/fincaComponent';
import virtualAccountComponent from '../modals/virtualAccountComponent';
export default {
    components: {
            fincaComponent,
            virtualAccountComponent
    },
    data(){
        return {
            data : null,
            topupPaymentSendToChecker:false,
            topupPayments:null,
            vendorPayment : null,
            payroll_id: null,
            batchHistory: null,
            payrollList:null,
            payrollName:null,
            payrollTotalAmount: null,
            payrollStatus:null,
            payrollDate: null,
            designation:null,
            sendForApproverButton: false,
            sendForCheckerButton: false,
            archiveBatchButton: false,
            deletButton: false,
            disapproveButton: false,
            processButton:false,
            rejectButton:false,
            reUploadButton:false,
            approverRejectButton:false,
            checkerRejectButton:false,
            currentUserName:null,
            currentUserRole:null,
            currentUserImage:null,
            firstLetter:null,
            msg:null,
            action:null,
            //already done action
            isAlreadySent:null,
            isAlreadyChecked:null,
            isAlreadyApproved:null,
            // flagTD: true,
            payTD: false,
            statusTD: false,
            // topup payment permissions
            add_topup_payment:null,
            delete_topup_payment:null,
            disapprove_topup_payment:null,
            topup_payment_send_to_checker:null,
            topup_payment_send_to_approver:null,
            archive_topup_payment:null,
            process_topup_payment:null,
            reject_topup_payment:null,
            exportBatch : false,
            failedCount : false,
            unRegisterNumberExport:false,
            paymentEngine: '',
            formDisapprove: new Form({
                comment:'',
                payroll_id: this.$route.params.id
            }),
            formRejectApprover: new Form({
                comment:'',
                payroll_id: this.$route.params.id
            }),
            formRejectChecker : new Form({
                comment:'',
                payroll_id: this.$route.params.id
            }),
            formReUpload : new Form({
                comment:'',
                payroll_id: this.$route.params.id
            }),
        };
    },
    updated() {

    },
    mounted(){
        this.$Progress.start();
        this.can('add_topup_payment|topup_payments|delete_topup_payment|disapprove_topup_payment|topup_payment_send_to_checker|topup_payment_send_to_approver|archive_topup_payment|process_topup_payment|reject_topup_payment').then(result => {
            if(result.topup_payments == true){
                this.exportBatch = true;
            }
            this.topupPayments = result.topup_payments;
            this.add_topup_payment = result.add_topup_payment;
            this.delete_topup_payment=result.delete_topup_payment;
            this.disapprove_topup_payment=result.disapprove_topup_payment;
            this.topup_payment_send_to_checker=result.topup_payment_send_to_checker;
            this.topup_payment_send_to_approver=result.topup_payment_send_to_approver;
            this.archive_topup_payment=result.archive_topup_payment;
            this.process_topup_payment=result.process_topup_payment;
            this.reject_topup_payment=result.reject_topup_payment;
        }).then(result => {
            if(this.topupPayments == true){
                axios.get('/api/getCurrentUserDetail')
                .then(res=> {
                    if(res.status == 200){
                        this.currentUserName=res.data.userName;
                        this.currentUserRole=res.data.role;
                        this.firstLetter=res.data.firstLetter;
                        this.currentUserImage= res.data.image;
                    }
                });
		        axios.get('/api/getTopupPaymentBatchSheetData/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.msg=res.data.msg;
                        this.users = res.data.users;
                        this.payroll_id = res.data.topuplist.id;
                        this.unRegisterNumberExport=res.data.unRegisterNumberExport
                        this.viewTopupPaymentSheet();
                        this.getPaymentEngineData();
                        this.designation=res.data.history.designation;
                        this.payrollList = res.data.topuplist;
                        this.batchHistory = res.data.history;
                        this.failedCount = res.data.failedCount;
  
                        this.payrollTotalAmount = res.data.topuplist.total_amount;
                        this.payrollStatus = res.data.topuplist.status;
                        var createdAt= this.payrollList.created_at;
                           if(res.data.isAlreadySent == '0'){
                                this.isAlreadySent = true;
                            }
                            if(res.data.isAlreadyChecked == '0'){
                                this.isAlreadyChecked = true;
                            }
                            if(res.data.isAlreadyApproved == '0'){
                                this.isAlreadyApproved= true;
                            }
                        this.payrollDate=''+moment(createdAt).format('MMM D, Y')+'';
                        if(this.payrollList.name != ''){
                            this.payrollName = this.payrollList.name;
                        }else{
                            var date = this.payrollList.created_at;
                            this.payrollName = ''+moment(date).format('M')+'';
                        }

                        if(this.topup_payment_send_to_checker == true && this.isAlreadySent == true){
                          this.sendForCheckerButton = true;
                        }

                        if(this.topup_payment_send_to_approver == true && this.isAlreadyChecked == true){
                           this.sendForApproverButton = true;
                        }
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
			        }
		        })
                .catch(err => {
                    this.$Progress.fail();
                });
            }else{
                this.$Progress.finish();
            }
        });
    },
    methods: {
        failedTransactionsExport: function () {
            this.$Progress.start();
            axios.post('/api/topupFailedTransactionsExport', {
                id : this.payrollList.id },{
                responseType: 'blob'
            }).then(res => {
                if(res.status == 200){
                    const url = URL.createObjectURL(new Blob([res.data], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'TopupBatchFailed.csv')
                    document.body.appendChild(link)
                    link.click()
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                }
            }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
            });
        },
        batchExport: function () {
            this.$Progress.start();
            axios.post('/api/topupBatchExport', {
                id : this.payrollList.id },{
                responseType: 'blob'
            }).then(res => {
                    if(res.status == 200){
                            const url = URL.createObjectURL(new Blob([res.data], {
                            type: 'application/vnd.ms-excel'
                        }))
                        const link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', 'TopupBatch.csv')
                        document.body.appendChild(link)
                        link.click()
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
        },
        unRegisterNumberExportFn: function () {
            this.$Progress.start();
            var id=this.$route.params.id
            axios.post('/api/topupUnRegisterNumberExport', {
                id : id,
            },{
                responseType: 'blob'
            }).then(res => {
                if(res.status == 200){
                    const url = URL.createObjectURL(new Blob([res.data], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'TopupBatchUnRegisteredWallet.csv')
                    document.body.appendChild(link)
                    link.click();
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                }
            }).catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','Some problem in your form data');
            });
        },
        getPaymentEngineData: function(){
            this.$Progress.start();
            axios.post("/api/getPaymentEngine")
            .then(res => {
                if(res.status == 200){
                    this.paymentEngine = res.data.data;
                    this.$Progress.finish();
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                }
            })
            .catch(err => {

                this.$Progress.fail();
                this.showAlertBox('error','Error to load form data');
            });
        },
        reUploadPopup(){
            this.action = 'reUpload';
            $('.reUpload').prop('disabled',false);
        },
        rejectCheckerPopup(){
            this.action = 'rejectChecker';
            $('.rejectChecker').prop('disabled',false);
        },
        rejectApproverPopup(){
            this.action='rejectApprover';
            $('.rejectApprover').prop('disabled',false);
        },
        deletePopup(){
            $('.delete').prop('disabled',false);
        },
        disapprovePopup(){
            $('.disapprove').prop('disabled',false);
            this.action='disapprove';
        },
        sendToCheckerPopup(){
            $('.sendtochecker').prop('disabled',false);
        },
        sendToApproverPopup(){
            $('.sendtoapprover').prop('disabled',false);
        },
        sendForChecker(){
            $('.sendtochecker').prop('disabled',true);
            var payroll_id = this.payroll_id;
            this.$Progress.start();
            axios.post('/api/topupSendForChecker',{payroll_id: payroll_id})
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully sent to checker');
                    $('#sendToChecker').modal('hide');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        sendForApprover(){
            $('.sendtoapprover').prop('disabled',true);
            var payroll_id = this.payroll_id;
            this.$Progress.start();
            axios.post('/api/topupSendForApprover',{
                payroll_id: payroll_id
            })
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully sent to approver');
                    $('#sendToApprover').modal('hide');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        rejectCheckerBatch(){
            $('.rejectChecker').prop('disabled',true);
            this.$Progress.start();
            this.formRejectChecker.post('/api/topupCheckerReject')
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully rejected');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        rejectApproverBatch(){
            $('.rejectApprover').prop('disabled',true);
            this.$Progress.start();
            this.formRejectApprover.post('/api/topupApproverReject')
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully rejected');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        disapproveBatch(){
            $('.disapprove').prop('disabled',true);
            this.$Progress.start();
            this.formDisapprove.post('/api/topupDisapproveBatch')
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully disapproved');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        // following code to be used in future
        // reUploadBatch(){
        //     $('.reUpload').prop('disabled',true);
        // 	this.$Progress.start();
        //     this.formReUpload.post('/api/makerReuploadTopup')
        //     .then(res => {
        //         if(res.status == 200){
        //             this.$Progress.finish();
        //           //  this.showToastBox('success','Batch successfully disapproved');
        //             // location.href = '{{url('generatePayroll').'?payroll_id=' . $payrolllist->id}}';
        //              var url='topupBulkUpload?topupId='+this.$route.params.id;
        //             this.$router.push('/'+url);
        //         }else{
        //             this.$Progress.fail();
        //             this.showAlertBox('error','There is some problem');
        //         }
        //     })
        //     .catch(err => {
        //         this.$Progress.fail();
        //         this.showAlertBox('error','There is some problem');
        //     });
        // },
        deleteBatch(){
            $('.delete').prop('disabled',true);
            var payroll_id = this.payroll_id;
            this.$Progress.start();
            axios.post('/api/topupDeleteBatch',{
                payroll_id: payroll_id
            })
            .then(res => {
                if(res.data.data.code == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully deleted');
                    $('#deletePop').modal('hide');
                    this.$router.push('/topupsPayments');
                }else{
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        archiveBatch(){
            $('.archived').prop('disabled',true);
            var payroll_id = this.payroll_id;
            this.$Progress.start();
            axios.post('/api/topupArchiveBatch',{
                payroll_id: payroll_id
            })
            .then(res => {
                if(res.status == 200){
                    this.$Progress.finish();
                    this.showToastBox('success','Batch successfully archived');
                    this.$router.push('/topupsPayments');
                    $('.archived').prop('disabled',false);
                }else{
                    $('.archived').prop('disabled',false);
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                }
            })
            .catch(err => {
                $('.archived').prop('disabled',false);
                this.$Progress.fail();
                this.showAlertBox('error','There is some problem');
            });
        },
        viewTopupPaymentSheet: function(){
                var that = this;
                $('#viewTopupPaymentTable').DataTable({
                    "paging": false,
                    "bInfo" : false,
                    sDom : '<"row view-filter"<"clearfix">><"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>',
                    ajax: {
                        "url": "/api/viewTopupSheet/"+this.$route.params.id,
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "data",
                        "complete": function (json, type) { //type return "success" or "parsererror"
                            if (type == "parsererror") {
                                that.$Progress.fail();
                            }else{
                                that.$Progress.finish();
                            }
                        }
                    },
                    deferRender: true,
                    columns: [
                        {data: 'name'},
                        {data: 'mobileNo'},
                        {data: 'network'},
                        {data: 'type'},
                        {data: 'amount'},
                    ],
                    "order": [[ 0, "desc" ]],
                });
            }
        },
        created() {
        }
    }
</script>
